import { useCallback, useState } from 'react';

import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { Box } from '@mui/material';
import { usePostHog } from 'posthog-js/react';

import Typography from '@/components/Typography';
import useUserDetails from '@/hooks/useUserDetails';

const RateAnswer = ({
  prompt,
  response,
  conversationId,
  version
}: {
  prompt: string;
  response: any[];
  conversationId: string;
  version: number;
}) => {
  const posthog = usePostHog();
  const { userEmail } = useUserDetails();
  const [rating, setRating] = useState(0);
  const iconProps = {
    width: '20px',
    height: '20px'
  };
  const sendPosthogResponse = useCallback(
    (score: number) => {
      const posthogEvent = {
        email: userEmail,
        prompt,
        response,
        score,
        timestamp: new Date().toISOString(),
        thread_id: conversationId,
        version
      };
      posthog.capture('ai_chat_score', posthogEvent);
    },
    [conversationId, posthog, prompt, response, userEmail, version]
  );
  return (
    <Box
      sx={{
        justifySelf: 'flex-end',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        color: 'var(--GX-Text-Disabled, #6C737A)'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '24px',
          alignSelf: 'flex-end'
        }}
      >
        {rating === 1 ? (
          <ThumbUpIcon
            data-testid='thumb-up'
            sx={iconProps}
          />
        ) : (
          <ThumbUpOutlinedIcon
            data-testid='thumb-up'
            sx={{ ...iconProps, cursor: rating === 1 ? undefined : 'pointer' }}
            onClick={
              rating === 1
                ? undefined
                : () => {
                    const newRating = 1;
                    setRating(newRating);
                    sendPosthogResponse(newRating);
                  }
            }
          />
        )}
        {rating === -1 ? (
          <ThumbDownIcon
            data-testid='thumb-down'
            sx={iconProps}
          />
        ) : (
          <ThumbDownOutlinedIcon
            data-testid='thumb-down'
            sx={{ ...iconProps, cursor: rating === -1 ? undefined : 'pointer' }}
            onClick={
              rating === -1
                ? undefined
                : () => {
                    const newRating = -1;
                    setRating(newRating);
                    sendPosthogResponse(newRating);
                  }
            }
          />
        )}
      </Box>
      <Typography
        sx={{
          fontSize: '12px'
        }}
      >
        Please double check responses
      </Typography>
    </Box>
  );
};

export default RateAnswer;
